<template>
  <div class="list-table-header" @scroll.passive="updatePosition" ref="scrollBox">
    <transition name="fade">
      <table class="table table-header" :style="{ fontSize: `${fontSize}px` }" v-show="isShow">
        <slot name="thead" />
      </table>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {
    fontSize: {
      type: Number,
      default: 12,
      requied: true,
    },
    tableScrollX: {
      type: Number,
      default: 0,
      requied: true,
    },
  },
  computed: {
    _tableScrollX: {
      get() {
        return this.tableScrollX
      },
      set(val) {
        this.$emit('update:tableScrollX', val)
      },
    },
    isShow: {
      get() {
        return this.$store.getters['Column/getIsShow']
      },
      set(val) {
        this.$store.commit('Column/setIsShow', val)
      },
    },
  },
  watch: {
    // スクロール値を監視して反映する
    tableScrollX(val) {
      this.$refs.scrollBox.scrollTo(val, 0)
    },
  },
  methods: {
    // テーブルコンテンツがスクロールされた時の処理
    updatePosition() {
      this._tableScrollX = this.$refs.scrollBox.scrollLeft
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/sass/_variables.scss';
.list-table-header {
  width: 100%;
  min-height: 78px;
  overflow-x: scroll;
  margin-bottom: 8px;
  -ms-overflow-style: none;

  .table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    margin-bottom: 8px;

    th {
      vertical-align: middle;
      padding: 4px 2px;
      background-color: #f0f0f0;
      transition: ease 0.3s;
      &.edit_cell {
        transition: ease 0.3s;
        background-color: #ffe6c0;
      }
    }
  }

  .table-header {
    border: 1px solid #cfcfcf;

    th {
      position: relative;
      border-right: 1px solid #cfcfcf;
      text-align: center;
      line-height: 2;

      br {
        line-height: 2;
      }
    }
  }
}
.residence {
  .list-table-header {
    .table-header {
      th {
        border-right: 1px solid #cfcfcf;
        background-color: $residence-bg-color;
        &.edit_cell {
          background-color: #ffe6c0;
        }
        &.editable {
          background-color: #ffe6c0;
        }
      }
    }
  }
}
.investment {
  .list-table-header {
    .table-header {
      th {
        border-right: 1px solid #f0f0f0;
        background-color: $investment-bg-color;
        &.edit_cell {
          background-color: #ffe6c0;
        }
        &.editable {
          background-color: #ffe6c0;
        }
      }
    }
  }
}
</style>
